export default __webpack_public_path__ + "static/6-hue-rotate-d0fce98b9b887880a12b99e3f43ba854.png";